import type { ColumnDef } from '@tanstack/vue-table'
import type { SegmentedCustomerInterface } from '~/types'

export const UnsupportedSegmentFiltersForSubscriptionBasedCompany = [
  'transaction_frequency',
]

export const UnsupportedSegmentFiltersForNonSubscriptionBasedCompany = [
  'subscription_plan',
  'subscription_amount',
  'subscription_interval',
]

export const SegmentTableColumns: Array<ColumnDef<SegmentedCustomerInterface>> = [
  {
    header: 'Customer',
    accessorKey: 'first_name',
    cell: ({ row }) =>
      `${row.original.first_name ?? '----'} ${row.original.last_name ?? '----'}`,
  },
  { header: 'E-Mail', accessorKey: 'email' },
  { header: 'Customer Id', accessorKey: 'company_customer_id' },
  {
    header: 'Phone Number',
    accessorKey: 'phone_no',
    cell: ({ row }) => row.original.phone_no ?? '----',
  },
] as const
